module.exports = __webpack_public_path__ + "assets/img/loyalty-4.81d59a7b.svg";